import { type ActionEvent, Controller } from "@hotwired/stimulus"

export default class ModalTriggerController extends Controller {
  openModal({ params }: ActionEvent): void {
    this.dispatch("openModal", { detail: params })
  }
}
